import _, { get } from 'lodash';
import { PERMISSION_TO_TEXT } from '../../constants/permissions.constants';
import { PAGINATION_MAPPINGS } from '../../constants/table.constants';
import { rolesToOrganizationName } from '../../lib/contact.utils';
import { contacts } from '../../services/bff.api';

export const ADMIN_CONTACTS_RESOURCE = {
  key: 'ADMIN_CONTACTS_RESOURCE',
  table: {
    enableSelect: false,
    defaultSort: 'lastName',
    dataLocation: '_embedded.contacts.result',
    searchParams: [
      'firstName',
      'lastName',
      'email',
      'phone',
      'function',
      'type',
      'roles',
      'net',
      'management',
      'community',
      'school',
      'branch',
      'organization',
      'name',
      'isApproved'
    ],
    fields: [
      { value: 'firstName', label: 'Voornaam', show: true, order: 0 },
      { value: 'lastName', label: 'Achternaam', show: true, order: 1 },
      { value: 'email', label: 'E-mail', show: false, order: 2 },
      { value: 'phone', label: 'Telefoon', show: false, order: 3 },
      { value: 'type', label: 'Type', show: true, order: 4 },
      { value: 'schoolNet', label: 'Schoolnet', blockSort: true, show: false, order: 5 },
      { value: 'schoolManagement', label: 'Schoolbestuur', blockSort: true, show: false, order: 6 },
      { value: 'schoolCommunity', label: 'Scholengemeenschap', blockSort: true, show: false, order: 7 },
      { value: 'school', label: 'School', blockSort: true, show: false, order: 8 },
      { value: 'schoolBranch', label: 'Vestiging', blockSort: true, show: false, order: 9 },
      { value: 'organization', label: 'Organisatie', blockSort: true, show: false, order: 10 },
      { value: 'function', label: 'Functie', show: false, order: 11 },
      { value: 'role', label: 'Rechten', show: true, order: 12 },
      { value: 'remark', label: 'Opmerkingen', show: false, order: 13 },
      { value: 'userName', label: 'Gebruikersnaam', show: false, order: 14 }
    ],
    highlight: (item) => !item?.isApproved,
    highlightType: 'danger',
    dataTransform: (data) =>
      data?.map((i) => {
        return {
          ...get(i, 'spoContactData'),
          id: get(i, 'id'),
          role:
            _.uniq(i?.spoContactData?.roles?.map((r) => PERMISSION_TO_TEXT?.[r?.role] || r?.role))?.join(', ') ?? '',
          schoolNet: rolesToOrganizationName(get(i, 'spoContactData.roles', []), 'netName', i?.spoContactData?.type),
          schoolManagement: rolesToOrganizationName(
            get(i, 'spoContactData.roles', []),
            'managementName',
            i?.spoContactData?.type
          ),
          schoolCommunity: rolesToOrganizationName(
            get(i, 'spoContactData.roles', []),
            'communityName',
            i?.spoContactData?.type
          ),
          school: rolesToOrganizationName(get(i, 'spoContactData.roles', []), 'schoolName', i?.spoContactData?.type),
          schoolBranch: rolesToOrganizationName(
            get(i, 'spoContactData.roles', []),
            'branchName',
            i?.spoContactData?.type
          ),
          organization: rolesToOrganizationName(
            get(i, 'spoContactData.roles', []),
            'organizationName',
            i?.spoContactData?.type
          )
        };
      }),
    pageMapping: PAGINATION_MAPPINGS.DEFAULT
  },
  api: {
    get: contacts.getAll
  }
};
